import { LineChart } from '@mui/x-charts/LineChart'

type Props = {
  name: string
  cbq: Record<string, number>
}

export const WhalesChartSimple = ({ name, cbq }: Props) => {
  // Get year range from cbq keys
  const years = Object.keys(cbq).map(q => Number(q.split('Q')[0]))
  const minYear = Math.min(...years)
  const maxYear = Math.max(...years)

  // Generate all quarters between minYear and maxYear
  const quarters: string[] = []

  for (let year = minYear; year <= maxYear; year++) {
    for (let q = 1; q <= 4; q++) {
      quarters.push(`${year}Q${q}`)
    }
  }

  // Map values using null with does not exist
  const values = quarters.map(quarter => (cbq[quarter] !== undefined ? cbq[quarter] : null))

  return (
    <LineChart
      xAxis={[
        {
          scaleType: 'point',
          data: quarters,
        },
      ]}
      series={[
        {
          data: values,
          label: `${name} CBQ`,
        },
      ]}
      height={400}
    />
  )
}
